import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { fadeUp, stagger } from '../lib/motion';
import { useSEO } from '../utils/seo';
import { useCopy, useLocale } from '../i18n/LocaleContext';

const COPY = {
  fr: {
    seoTitle: 'Page introuvable — Le Placard à Doudous', seoDescription: 'Cette page s’est égarée entre les pages.',
    title: 'Cet ami tout doux s’est égaré entre les pages…', text: 'La page que vous cherchez n’existe pas ou a changé d’étagère. Le reste du placard vous attend.',
    shop: 'Découvrir la boutique', home: 'Retour à l’accueil',
  },
  en: {
    seoTitle: 'Page not found — Le Placard à Doudous', seoDescription: 'This page has wandered off between the pages.',
    title: 'This cuddly friend has wandered off between the pages…', text: 'The page you’re looking for doesn’t exist or has moved to another shelf. The rest of the cupboard is waiting for you.',
    shop: 'Discover the shop', home: 'Back to the homepage',
  },
};

export default function NotFound() {
  const c = useCopy(COPY);
  const { lp } = useLocale();
  useSEO(c.seoTitle, c.seoDescription);
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4 pt-24">
      <motion.div variants={stagger} initial="hidden" animate="show" className="max-w-xl text-center">
        <motion.p variants={fadeUp} className="font-serif text-[8rem] font-black leading-[0.85] tracking-[-0.045em] text-primary sm:text-[11rem]" aria-hidden="true">
          404
        </motion.p>
        <motion.h1 variants={fadeUp} className="mt-4 font-serif text-2xl text-foreground sm:text-3xl">
          {c.title}
        </motion.h1>
        <motion.p variants={fadeUp} className="mx-auto mt-4 max-w-md font-sans text-sm leading-relaxed text-muted-foreground">
          {c.text}
        </motion.p>
        <motion.div variants={fadeUp} className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Button asChild className="rounded-full bg-primary px-7 font-sans font-bold text-primary-foreground shadow-soft transition-[box-shadow,transform] duration-200 hover:bg-[hsl(var(--brand-fuchsia-ink))] hover:shadow-ambient active:scale-[0.98]">
<Link to={lp('/boutique')}>
              {c.shop}
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
</Button>
          <Link to={lp('/')} className="font-sans text-sm font-semibold text-foreground underline-offset-4 transition-colors duration-200 hover:underline">
            {c.home}
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
}
